import { useContentful } from '@ecomm/shared-apollo'

import { ALL_NINETAILED_FEATURE_FLAGS_QUERY } from './allNinetailedFeatureFlagsQuery'
import { allNinetailedFeatureFlagsDataSchema } from './useNinetailedFeatureFlag/schema'

export const useNinetailedFeatureFlagsQuery = () => {
  const ninetailedFeatureFlagsQueryResult = useContentful(
    ALL_NINETAILED_FEATURE_FLAGS_QUERY
  )

  const { data: ninetailedFeatureFlagData } =
    allNinetailedFeatureFlagsDataSchema.parse(ninetailedFeatureFlagsQueryResult)

  return ninetailedFeatureFlagData
}
